import {
  BASE_REALITY_ADDRESSES,
  BASE_SEPOLIA_REALITY_ADDRESSES,
  GNOSIS_CHIADO_REALITY_ADDRESSES,
  GNOSIS_REALITY_ADDRESSES,
  MAINNET_REALITY_ADDRESSES,
  OPTIMISM_SEPOLIA_REALITY_ADDRESSES,
  POLYGON_REALITY_ADDRESSES,
  SEPOLIA_REALITY_ADDRESSES,
  UNICHAIN_REALITY_ADDRESSES,
  UNICHAIN_SEPOLIA_REALITY_ADDRESSES,
  ZKSYNC_SEPOLIA_REALITY_ADDRESSES,
} from "./reality-addresses";

const arbitrableWhitelist = {
  1: [
    "0x126697b552b83f08c7ebebae8d13eae2871e4e1e",
    "0x250aa88c8f54f5e70b94214380342f0d53e42f6c",
    "0x2e3b10abf091cdc53cc892a50dabdb432e220398",
    "0x594ec762b59978c97c82bc36ab493ed8b1f1f368",
    "0x6341ec8f3f23689bd6ea3cf82fe34c3a0481c30a",
    "0x701cabaf65ed3974925fb94988842a29d2ce7aa3",
    "0x7ecffaa0247227a29d613adb3b1b47e44f0f53cb",
    "0x916deab80dfbc7030277047cd18b233b3ce5b4ab",
    "0xc5e9ddebb09cd64dfacab4011a0d5cedaf7c9bdb",
    "0xcb4aae35333193232421e86cd2e9b6c91f3b125f",
    "0xd7e143715a4244634d74201959372e81a3623a2a",
    "0xe0e1bc8c6cd1b81993e2fcfb80832d814886ea38",
    "0xe5bcea6f87aaee4a81f64dfdb4d30d400e0e5cf4",
    "0xebcf3bca271b26ae4b162ba560e243055af0e679",
    "0xf339047c85d0dd2645f2bd802a1e8a5e7af61053",
    "0xbE9834097A4E97689d9B667441acafb456D0480A", // PoH V2
    ...MAINNET_REALITY_ADDRESSES,
  ].map((address) => address.toLowerCase()),
  100: [
    "0x2a2bab2c2d4eb5007b0389720b287d4d19dc4001",
    "0x2b6869e4f1d6104989f15da7454dbf7a01310bb8",
    "0x2e39b8f43d0870ba896f516f78f57cde773cf805",
    "0x2f19f817bbf800b487b7f2e51f24ad5ea0222463",
    "0x54068a67441a950ff33afa5a3247acc7188d0789",
    "0x54a92c21c6553a8085066311f2c8d9db1b5e6610",
    "0x66260c69d03837016d88c9877e61e08ef74c59f2",
    "0x70533554fe5c17caf77fe530f77eab933b92af60",
    "0x76944a2678a0954a610096ee78e8ceb8d46d5922",
    "0x86e72802d9abbf7505a889721fd4d6947b02320e",
    "0x957a53a994860be4750810131d9c876b2f52d6e1",
    "0x9FE4D9E4989ad031FDc424d8C34D77E70aA0b269",
    "0xa78ec5742a5d360f92f6d6d7e775fb35ab559a51",
    "0xaeecfa44639b61d2e0a9534d918789d94a24a9de",
    "0xd5994f15be9987104d9821aa99d1c97227c7c08c",
    "0xf7de5537ecd69a94695fcf4bcdbdee6329b63322",
    "0xa4AC94C4fa65Bb352eFa30e3408e64F72aC857bc", // PoH V2
    "0x5aAF9E23A11440F8C1Ad6D2E2e5109C7e52CC672", // Seer Market registry on Curate
    "0xeE1502e29795Ef6C2D60F8D7120596abE3baD990", // Kleros Tokens registry on Curate
    ...GNOSIS_REALITY_ADDRESSES,
  ].map((address) => address.toLowerCase()),
  11155111: [
    "0x73E4F71e5ecE8d1319807DC7cd2EAA9Fda8F5182",
    "0x1ec9729366e4C3eb8b8Ea776935508188051C0F4",
    "0xb994886066B17cfa0fE088C5933498B17FE66A50",
    ...SEPOLIA_REALITY_ADDRESSES,
  ].map((address) => address.toLowerCase()),
  300: [...ZKSYNC_SEPOLIA_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  130: [...UNICHAIN_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  137: [...POLYGON_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  1301: [...UNICHAIN_SEPOLIA_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  10200: [...GNOSIS_CHIADO_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  11155420: [...OPTIMISM_SEPOLIA_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  8453: [...BASE_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
  84532: [...BASE_SEPOLIA_REALITY_ADDRESSES].map((address) => address.toLowerCase()),
};

export default arbitrableWhitelist;
